import lesson1 from './lesson1.json';
import lesson2 from './lesson2.json';

const lessons = [lesson1, lesson1, lesson2];

export default lessons;